export const ensureShadowRoot = (host: HTMLElement): ShadowRoot => {
  const existing = host.shadowRoot as ShadowRoot | null;
  if (existing) return existing;
  return host.attachShadow({ mode: "open" });
};

const ensureHostContainer = (id: string) => {
  const existing = document.getElementById(id) as HTMLElement | null;
  if (existing) return existing;

  const el = document.createElement("div");
  el.id = id;
  el.style.display = "inline-block";
  el.style.position = "relative";

  document.body.appendChild(el);
  return el;
};

export const ensurePortalContainer = (shadow: ShadowRoot) => {
  let el = shadow.querySelector<HTMLElement>("#telekomId-portal");
  if (el) return el;

  el = document.createElement("div");
  el.id = "telekomId-portal";
  shadow.appendChild(el);
  return el;
};

export const ensureContainer = (shadow: ShadowRoot) => {
  const existing = shadow.getElementById(
    "telekomId-root",
  ) as HTMLElement | null;
  if (existing) return existing;

  const el = document.createElement("div");
  el.id = "telekomId-root";
  shadow.appendChild(el);
  return el;
};

export const ensureChatbotHolder = (): HTMLElement => {
  const host = document.getElementById("cosid_md-chatbot");
  if (!host) throw new Error("Missing #cosid_md-chatbot host");

  let holder = host.querySelector<HTMLElement>("#cosid-chat-holder");
  if (holder) return holder;

  holder = document.createElement("div");
  holder.id = "cosid-chat-holder";
  host.appendChild(holder);
  return holder;
};

export const resolveDesiredHost = (host?: string | HTMLElement | null) => {
  if (!host) return null;

  if (typeof host === "string") {
    return (document.querySelector(host) as HTMLElement | null) ?? null;
  }

  return host;
};

const stabilizeHost = (el: HTMLElement) => {
  if (!el.style.minWidth) el.style.minWidth = "1px";
  if (!el.style.minHeight) el.style.minHeight = "1px";

  // Keep display untouched to avoid affecting host layout unexpectedly.
  // if (!el.style.display) el.style.display = "inline-block";
};

const isUsableEnough = (el: HTMLElement | null): el is HTMLElement => {
  if (!el) return false;
  if (!el.isConnected) return false;
  return true;
};

export const ensureUsableHostOrFallback = (
  explicitHost: HTMLElement | null,
  fallbackHost: HTMLElement | null,
) => {
  if (isUsableEnough(explicitHost)) {
    stabilizeHost(explicitHost);
    return explicitHost;
  }

  if (isUsableEnough(fallbackHost)) {
    stabilizeHost(fallbackHost);
    return fallbackHost;
  }

  return ensureHostContainer("telekomId-host");
};
